/**
 * Asking again for notifications - at a moment they would help, offering what this person uses
 * Timo for, and at most once every two weeks per device. Lives as a row in "Timo noticed".
 */
import { enablePush, pushEnabled, pushState } from "../lib/push";
import { byId, on, toast } from "../lib/dom";
import { state } from "../state";
import { sameDay } from "../lib/time";

const KEY = "timo-push-asked";
const EVERY_MS = 14 * 86_400_000;

function due() {
  if (pushEnabled() || pushState() === "unsupported") return false;
  try { return Date.now() - Number(localStorage.getItem(KEY) ?? 0) > EVERY_MS; } catch { return false; }
}
const snooze = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch { /* private mode */ } };

/** Meetings or tasks: whichever this person actually did more of in the last two weeks. */
function focus(): "meetings" | "tasks" {
  const since = Date.now() - 14 * 86_400_000;
  const meetings = state.meetings.filter((m) => (m.startedAt?.getTime() ?? 0) > since).length;
  const done = state.tasks.filter((t) => t.status === "done" && (t.completedAt?.getTime() ?? 0) > since).length;
  return meetings === 0 && done > 0 ? "tasks" : "meetings";
}

export function pushAskRow(): string {
  if (!due()) return "";
  // Only when it would help today: a meeting on the calendar, or a habit of recording them.
  const meetingToday = state.events.some((e) => e.kind === "meeting" && sameDay(e.start, new Date()) && e.start.getTime() > Date.now());
  if (!meetingToday && !state.meetings.length && !state.tasks.some((t) => t.dueAt)) return "";
  const f = focus();
  const [title, body] = f === "tasks"
    ? ["Get told when a task is due", "One note in the morning with what's due, and nothing else you didn't ask for."]
    : ["Get a ping when a meeting starts", "Timo taps you as the call begins, so you can record it with one click."];
  const blocked = pushState() === "denied";
  return `<div class="inbox-row" id="pushAsk"><div class="source">◔</div><div><strong>${title}</strong><p>${blocked ? "Notifications are blocked for timonow.com. Click the lock icon next to the address, allow notifications, then reload." : body}</p></div><div class="page-actions" style="align-self:center">${blocked ? "" : `<button class="btn primary" id="pushAskYes">Turn on</button>`}<button class="btn" id="pushAskNo">Not now</button></div></div>`;
}

export function bindPushAsk() {
  on(byId("pushAskNo"), "click", () => { snooze(); byId("pushAsk")?.remove(); });
  on(byId("pushAskYes"), "click", async () => {
    snooze();
    const r = await enablePush();
    toast(r.ok ? "Notifications on for this device" : r.reason ?? "Couldn't turn notifications on");
    byId("pushAsk")?.remove();
  });
}
